import { render } from "./EmojiWrapper.vue?vue&type=template&id=00d1525f&scoped=true"
import script from "./EmojiWrapper.vue?vue&type=script&lang=ts"
export * from "./EmojiWrapper.vue?vue&type=script&lang=ts"

import "./EmojiWrapper.vue?vue&type=style&index=0&id=00d1525f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00d1525f"

export default script